import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { containerStagger, fadeUpOnView } from '../../animations/textAnimation';
import './home.css';

export default function Home() {
  const { t } = useTranslation();

  return (
    <motion.div
      className='home-wrapper'
      variants={containerStagger}
      initial='hidden'
      whileInView='visible'
      viewport={{ once: true, amount: 0.8 }}
    >
      <motion.h1 
        className='home-h1'
        variants={fadeUpOnView}
      >
        {t('home.title')}
      </motion.h1>
      <motion.h2 
        className='home-h2'
        variants={fadeUpOnView}
      >
        {t('home.subtitle')}
      </motion.h2>
    </motion.div>
  );
}